import { useMediaQuery } from "usehooks-ts";
import CenteredContainer from "@core/components/layout/centeredContainer";
import DistributorOnboarding from "../components/onboarding";
import { DownloadAppPrompt } from "../components/download-app-prompt";

export default function Signup() {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (!isDesktop) {
    return <DownloadAppPrompt />;
  }

  return (
    <CenteredContainer>
      <DistributorOnboarding />
    </CenteredContainer>
  );
}
